import ApiWrapper from "@/services/ApiWrapper";

var UsageService = {
    getApplicationStatistics({ since }) {
        return ApiWrapper.post('/api/devops/Infos/ApplicationStatistics', { since });
    }
}

export default UsageService
